import { render, staticRenderFns } from "./tutorInTheAssessmentOK.vue?vue&type=template&id=f2c2b4ba&scoped=true&"
import script from "./tutorInTheAssessmentOK.vue?vue&type=script&lang=js&"
export * from "./tutorInTheAssessmentOK.vue?vue&type=script&lang=js&"
import style0 from "./tutorInTheAssessmentOK.vue?vue&type=style&index=0&id=f2c2b4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c2b4ba",
  null
  
)

export default component.exports